import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {catchError, switchMap} from 'rxjs/operators';
import {GetMediaResponse, MediaRequest, MediaURL} from '../../models/models';
import * as firebase from 'firebase';
import UploadTask = firebase.storage.UploadTask;


@Injectable({
    providedIn: 'root'
})
export class MediaService {

    firebaseProject;
    defaultStorage;
    storageRef;

    constructor(private httpClient: HttpClient) {
    }


    initialize(firebaseStorageApp: firebase.app.App) {
        // console.log('media.service.initialize: ', firebaseStorageApp);
        this.firebaseProject = firebaseStorageApp;
        this.defaultStorage = firebaseStorageApp.storage();
        this.storageRef = firebaseStorageApp.storage().ref();
    }

    /**
     * Get downloadable URL from the GS url
     * @param {string} gsURL complete GS URL path
     * @returns {Observable<any>}
     */
    getDownloadURLFromGSURL(gsURL: string): Observable<any> {
        return from(this.defaultStorage.refFromURL(gsURL).getDownloadURL());
    }

    /**
     * To get the http url from media id
     * @param {number} mediaId : primary key of the media
     * @returns {Observable<GetMediaResponse>}
     */
    getMediaById(mediaId: number): Observable<GetMediaResponse> {
        const mediaUrl = environment.remoteDataService + '/media/' + mediaId;
        return this.httpClient.get<MediaURL>(mediaUrl).pipe(
            switchMap(mediaResp => {
                return this.getHTTPUrlFromResponse(mediaResp);
            }),
            catchError((e) => {
                console.log('media.service.getMediaById catchError: ', e);
                console.log('media.service.getMediaById. status code: ', e.status);
                if (e.status === 400 && e.error === 'url expired') {
                    return this.refreshMediaUrl(mediaId);
                } else {
                    return throwError(e);
                }
            })
        );
    }

    /**
     * DON"T CALL THIS DIRECTLY UNLESSS NECESSARY
     * @param {number} mediaId
     * @returns {Observable<GetMediaResponse>}
     */
    refreshMediaUrl(mediaId: number): Observable<GetMediaResponse> {
        // console.log('media.service.refreshMediaUrl: ', mediaId);
        const mediaUrl = environment.remoteDataService + '/media/refresh-signed-url/' + mediaId;
        return this.httpClient.post<MediaURL>(mediaUrl, {}).pipe(
            switchMap(mediaResponse => {
                return this.getHTTPUrlFromResponse(mediaResponse);
            }),
            catchError((e: HttpErrorResponse) => {
                return throwError(e);

            })
        );
    }

    /**
     * TO create a new media entry in the table
     * @param {MediaRequest} mediaRequestObject containit the necessary parameter of media request
     * @returns {Observable<MediaURL>}
     */
    insertMedia(mediaRequestObject: MediaRequest): Observable<MediaURL> {

        const mediaPostURL = environment.remoteDataService + '/media';

        return this.httpClient.post<MediaURL>(mediaPostURL, mediaRequestObject);
    }

    /**
     * To update an existing media entry
     * @param {MediaRequest} mediaRequestObject containing the necessary parameter for media update
     * @param {string} mediaId media id
     * @returns {Observable<MediaURL>}
     */
    updateMedia(mediaRequestObject: MediaRequest, mediaId: number): Observable<MediaURL> {

        const mediaPostURL = environment.remoteDataService + '/media/' + mediaId;

        return this.httpClient.put<MediaURL>(mediaPostURL, mediaRequestObject);
    }

    /**
     * To upload file to firebase
     * @param {File | Blob} fileOrBlob:File or blob to upload file to upload
     * @param {string} fullPath actual GS url or Http url
     * @returns {AngularFireUploadTask} task subscription
     */
    uploadFile(fileOrBlob: File | Blob, fullPath: string): UploadTask {
        if (fullPath.includes('gs://')) {
            return this.defaultStorage.refFromURL(fullPath).put(fileOrBlob);
        } else {
            throwError('Incorrect path passed only GS is allowed for now' + fullPath);
        }
    }

    private getHTTPUrlFromResponse(mediaUrlResponse: MediaURL): Observable<any> {
        if (mediaUrlResponse.secure_url && mediaUrlResponse.secure_url.includes('gs://')) {
            return of({
                mediaUrl: mediaUrlResponse,
                httpUrlObservable: from(this.defaultStorage.refFromURL(mediaUrlResponse.secure_url).getDownloadURL())
            });
        } else {
            return of({mediaUrl: mediaUrlResponse, httpUrlObservable: of(mediaUrlResponse.signed_url)});
        }
    }
}
